// extracted by mini-css-extract-plugin
export default {"auth-error":"AuthError_auth-error__JoF5V","auth-error-contents":"AuthError_auth-error-contents__sEZWg"};